var _circle, _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayInterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.3986,
    y: 20.2557,
    width: 13.393,
    height: 8.878,
    rx: 1.19567,
    fill: "#BFDFBA",
    stroke: "#AED7A8",
    strokeWidth: 0.79711
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4298 24.6765C25.4298 24.0162 25.9651 23.4809 26.6255 23.4809H29.7928V25.9088H26.6255C25.9651 25.9088 25.4298 25.3735 25.4298 24.7131V24.6765Z",
    fill: "#BFDFBA",
    stroke: "#AED7A8",
    strokeWidth: 0.79711
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9806,
    y: 21.5458,
    width: 13.393,
    height: 8.878,
    rx: 1.19567,
    fill: "#BFDFBA",
    stroke: "black",
    strokeWidth: 0.79711
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0118 25.9666C28.0118 25.3063 28.5472 24.771 29.2075 24.771H32.3748V27.1989H29.2075C28.5472 27.1989 28.0118 26.6636 28.0118 26.0032V25.9666Z",
    fill: "#BFDFBA",
    stroke: "black",
    strokeWidth: 0.79711
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3986,
    y: 20.2557,
    width: 13.393,
    height: 8.878,
    rx: 1.19567,
    fill: "#BFDFBA",
    stroke: "#AED7A8",
    strokeWidth: 0.79711
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4298 24.6765C25.4298 24.0162 25.9651 23.4809 26.6255 23.4809H29.7928V25.9088H26.6255C25.9651 25.9088 25.4298 25.3735 25.4298 24.7131V24.6765Z",
    fill: "#BFDFBA",
    stroke: "#AED7A8",
    strokeWidth: 0.79711
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9806,
    y: 21.5458,
    width: 13.393,
    height: 8.878,
    rx: 1.19567,
    fill: "#BFDFBA",
    stroke: "black",
    strokeWidth: 0.79711
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0118 25.9666C28.0118 25.3063 28.5472 24.771 29.2075 24.771H32.3748V27.1989H29.2075C28.5472 27.1989 28.0118 26.6636 28.0118 26.0032V25.9666Z",
    fill: "#BFDFBA",
    stroke: "black",
    strokeWidth: 0.79711
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25C43 34.9411 34.9411 43 25 43C15.0589 43 7 34.9411 7 25C7 15.0589 15.0589 7 25 7C34.9411 7 43 15.0589 43 25ZM10.2942 25C10.2942 33.1218 16.8782 39.7058 25 39.7058C33.1218 39.7058 39.7058 33.1218 39.7058 25C39.7058 16.8782 33.1218 10.2942 25 10.2942C16.8782 10.2942 10.2942 16.8782 10.2942 25Z",
    fill: "#BFDFBA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9299 28.6953C41.8161 28.9008 42.709 28.3494 42.8327 27.4482C43.1009 25.4947 43.0468 23.5065 42.6689 21.5636C42.186 19.0806 41.1852 16.7273 39.7317 14.6571C38.2783 12.5869 36.4048 10.8463 34.2335 9.5487C32.5344 8.53337 30.6829 7.80717 28.7544 7.39589C27.8647 7.20615 27.0427 7.85872 26.9351 8.762C26.8275 9.66528 27.4758 10.4756 28.3614 10.6835C29.8311 11.0286 31.2422 11.5987 32.5437 12.3765C34.3176 13.4366 35.8482 14.8586 37.0357 16.55C38.2231 18.2413 39.0408 20.1639 39.4353 22.1925C39.7248 23.6808 39.7817 25.2016 39.6071 26.7011C39.5019 27.6047 40.0438 28.4897 40.9299 28.6953Z",
    fill: "#8BC582"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayInterest);
export default __webpack_public_path__ + "static/media/pay_interest.374eb6f229e435793f39e5c1aa3d7d5f.svg";
export { ForwardRef as ReactComponent };